import { generateThemeColors, palette } from '../colors';
import baseTheme from './base';

const colors = generateThemeColors(palette, 'dark');

export default {
    ...baseTheme,
    colors,
};
